import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { admin_cse } from "@/config/roles";
import { EditNoteWrapper } from "@/portals/(shared)/(new-note)/components/EditNoteWrapper";
import { isAuthorized } from "@/utils/authToken";
import { usePatientDetails } from "@/features/patient/api/queries/usePatientDetails";

import { ADVANCED_CARE_ACTIVITY_INITIAL_VALUES } from "./constants";
import { AdvancedCareActivityForm } from "./components/AdvancedCareActivityForm";

import "./AdvancedCare.styles.scss";

export const AdvancedCareActivityNewNote = () => {
  const { patientId } = useParams();
  const { data: patient } = usePatientDetails({ patientId });

  const current_user = useSelector((state) => state.auth.profile);
  const [initialValues, setInitialValues] = useState();

  // setup form state
  useEffect(() => {
    if (!patient || !current_user) {
      return;
    }

    const noteStateToClone = ADVANCED_CARE_ACTIVITY_INITIAL_VALUES;
    const localInitialValues = cloneDeep(noteStateToClone);

    localInitialValues.patient_id = patient.username;
    localInitialValues.patient_first_name = patient.first_name;
    localInitialValues.patient_last_name = patient.last_name;

    if (isAuthorized(admin_cse)) {
      localInitialValues.admin_name = current_user.name;
      localInitialValues.admin_id = current_user.username;
    } else {
      localInitialValues.provider_id = current_user.username;
      localInitialValues.provider_name = current_user.name;
      localInitialValues.provider_type = current_user.provider_type;
      localInitialValues.provider_cp_credentials = current_user.cp_credentials;
    }

    setInitialValues(localInitialValues);
  }, [patient, current_user]);

  return (
    <EditNoteWrapper patientId={patientId}>
      <AdvancedCareActivityForm
        isEditing={true}
        nameToSign={current_user?.name}
        noteState={initialValues}
        patientId={patient?.username}
      />
    </EditNoteWrapper>
  );
};
